/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PremiumInputs */

const en_premium = /** @type {(inputs: PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const es_premium = /** @type {(inputs: PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const fr_premium = /** @type {(inputs: PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const de_premium = /** @type {(inputs: PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const ja_premium = /** @type {(inputs: PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレミアム`)
};

const zh_premium = /** @type {(inputs: PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高级`)
};

const ar_premium = /** @type {(inputs: PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مميز`)
};

const id_premium = /** @type {(inputs: PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const it_premium = /** @type {(inputs: PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const ru_premium = /** @type {(inputs: PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Премиум`)
};

const pt_premium = /** @type {(inputs: PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const ko_premium = /** @type {(inputs: PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프리미엄`)
};

/**
* | output |
* | --- |
* | "Premium" |
*
* @param {PremiumInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const premium = /** @type {((inputs?: PremiumInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PremiumInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_premium(inputs)
	if (locale === "es") return es_premium(inputs)
	if (locale === "fr") return fr_premium(inputs)
	if (locale === "de") return de_premium(inputs)
	if (locale === "ja") return ja_premium(inputs)
	if (locale === "zh") return zh_premium(inputs)
	if (locale === "ar") return ar_premium(inputs)
	if (locale === "id") return id_premium(inputs)
	if (locale === "it") return it_premium(inputs)
	if (locale === "ru") return ru_premium(inputs)
	if (locale === "pt") return pt_premium(inputs)
	return ko_premium(inputs)
});